import { useEffect, useMemo, useRef } from 'react';
import * as Cesium from 'cesium';
import { ImageryLayer } from 'resium';

import { useGlobus } from './GlobusProvider';

export const BorderImageryProvider: React.FC = () => {
  const { bordersEnabled: enabled } = useGlobus();
  const layerRef = useRef<Cesium.ImageryLayer | null>(null);

  const imageryProviderBorders = useMemo(() => {
    return new Cesium.OpenStreetMapImageryProvider({
      url: 'https://globusserver.de/cgi-bin/ImagonTileCache2.pl?osmborders/',
    });
  }, []);

  useEffect(() => {
    if (layerRef.current) {
      // Get the viewer instance from the global Cesium context
      const viewer = (window as any).cesiumViewer as Cesium.Viewer;
      if (viewer && layerRef.current) {
        viewer.imageryLayers.raiseToTop(layerRef.current); // ✅ Bring to top explicitly
      }
    }
  }, [enabled]);

  return (
    <ImageryLayer
      ref={(layer) => {
        if (layer && layer.cesiumElement) {
          layerRef.current = layer.cesiumElement;
        }
      }}
      show={enabled}
      imageryProvider={imageryProviderBorders}
    />
  );
};
